import { navigate } from "gatsby";
import React from "react";
import { useInView } from "react-intersection-observer";
import { cn, currentPath } from "../../lib/helpers";
import { ArrowElbow } from "../icon/arrow-elbow";
import { List } from "../icon/list";

import * as styles from "../web-form-field.module.css";
import { SearchPopup } from "./snowflake/search";

// @todo change to flat menu list structure with "indent" option
// @todo share with configs in pills.js

const RESOURCES_PREFIX = "/resources/";

const filterList = [
  {
    label: "Latest posts",
    url: "/blog/",
  },
  {
    label: "Product news",
    url: `${RESOURCES_PREFIX}blog/product/`,
    // waiting: true,
    // color: "blue-400",
  },
  {
    label: "Go to market",
    url: `${RESOURCES_PREFIX}blog/go-to-market/`,
    // color: "blue-100",
    options: [
      {
        label: "Sales",
        url: `${RESOURCES_PREFIX}blog/sales/`,
      },
      {
        label: "Marketing",
        url: `${RESOURCES_PREFIX}blog/marketing/`,
      },
      {
        label: "Developer relations",
        url: `${RESOURCES_PREFIX}blog/community/developer-relations/`,
      },
    ],
  },
  {
    label: "Customer stories",
    url: `/customers/`,
    // waiting: true,
    // color: "green-400",
  },
  {
    label: "Podcast",
    url: "/podcast/",
  },
  {
    label: "Company news",
    url: `${RESOURCES_PREFIX}company-news/`,
    // color: "orange-800",
  },
  {
    label: "Blog archive",
    url: `${RESOURCES_PREFIX}blog/`,
  },
];

const pillClasses =
  "inline-block border-l border-dark-5 hover:border-link p-2 hover:text-link flex gap-2 items-center";

export const Filters = () => {
  const { ref, inView } = useInView({
    initialInView: true,
  });
  const path = `/${currentPath()}`;

  return (
    <>
      <div ref={ref}></div>
      <div className="pt-6 xl:pt-0 xl:hidden max-w-screen-sm mx-auto px-4">
        <SelectMenu menu={filterList} />
      </div>
      <div
        className={cn(
          "hidden xl:block",
          "z-40 left-0 top-24 pt-8 pl-12 text-base",
          inView ? "absolute" : "fixed"
        )}
      >
        <ul>
          {filterList.map((f) => {
            return f.options ? (
              <li key={f.label}>
                <a
                  href={f.url}
                  className={cn(
                    pillClasses,
                    path === f.url ? "font-semibold" : ""
                  )}
                >
                  {f.label}
                </a>
                {f.options && (
                  <ul>
                    {f.options.map((sub, i) => (
                      <li key={i}>
                        <a
                          href={sub.url}
                          className={cn(
                            pillClasses,
                            path === sub.url ? "font-semibold border-green-emerald" : "",
                            "pl-2 flex gap-2 items-center"
                          )}
                        >
                          <span className="text-black">
                            <ArrowElbow />
                          </span>
                          {sub.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ) : (
              <li key={f.label}>
                <a
                  href={f.url}
                  className={cn(
                    pillClasses,
                    path === f.url ? "font-semibold" : ""
                  )}
                >
                  {f.label}
                </a>
              </li>
            );
          })}
          {/* <li className="ml-5">
            <SearchPopup iconOnly={true} results="post" />
          </li> */}
        </ul>
        {/* <div className="p-2.5 px-3.5 rounded-2xl border border-dark-10">
          <Subscribe
            section={{
              attribution: { campaignType: "filters" },
              buttonText: "Subscribe",
              buttonClasses: "bg-dark-30 hover:bg-green-emerald text-black",
            }}
          />
        </div> */}
      </div>
    </>
  );
};

export const SelectMenu = ({ menu, label }) => (
  <div
    className={cn(
      styles.selectWrapper,
      "flex gap-2 items-center p-2.5 px-3.5 rounded-2xl",
      "bg-white focus:text-black border border-dark-10"
    )}
  >
    <List size={20} />
    <select
      className="w-full appearance-none focus:ring-0 outline-none bg-white"
      onChange={(e) => {
        if (e.target.value !== "none") {
          navigate(e.target.value);
        }
      }}
    >
      <option>{label || "Categories"}</option>
      {menu.map((tag, i) => {
        if (tag.options) {
          return (
            <React.Fragment key={i}>
              <option value={tag.url}>{tag.label}</option>
              {tag.options.map((opt, j) => (
                <option value={opt.url} key={`${i}-${j}`}>
                  - {opt.label}
                </option>
              ))}
            </React.Fragment>
          );
        }
        return (
          <option value={tag.url} key={i}>
            {tag.label}
          </option>
        );
      })}
    </select>
  </div>
);
